import { render, staticRenderFns } from "./ProductPartInfoDialog.vue?vue&type=template&id=16ba70b7&scoped=true&"
import script from "./ProductPartInfoDialog.vue?vue&type=script&lang=js&"
export * from "./ProductPartInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductPartInfoDialog.vue?vue&type=style&index=0&id=16ba70b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba70b7",
  null
  
)

export default component.exports